import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import MuiLink from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useAPI, useQuery, usePagination, Row } from '@mybonus/ui';
import { Link } from 'react-router-dom';

import { Page, ErrorPopup, DateTime, Paginate } from '../../components';

export function NotificationListView() {
	const { pagination: input, setPage } = usePagination();
	const { api } = useAPI();

	const list = useQuery(
		'admin.message.notification.construct.list',
		(args) => api.admin.message.notification.construct.list.query(args),
		input,
	);

	return (
		<Page title="Notifications">
			<Row apart>
				<Link to="/app/marketing/messages/notifications/create">
					<Button variant="contained">New Notification</Button>
				</Link>

				<Paginate state={list.data?.pagination} setPage={setPage} />
			</Row>

			{list.isLoading && <LinearProgress />}

			<ErrorPopup error={list.error} onRetry={list.load} onClose={list.reset} />

			{list && (
				<TableContainer component={Paper}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>ID</TableCell>
								<TableCell>Name</TableCell>
								<TableCell>Created</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{list.data?.items.map((row) => (
								<TableRow key={row.id}>
									<TableCell scope="row">{row.id}</TableCell>
									<TableCell>
										<MuiLink
											component={Link}
											to={`/app/marketing/messages/notifications/list/${row.id}`}
										>
											{row.name}
										</MuiLink>
									</TableCell>
									<TableCell>
										<DateTime date={row.created_at} />
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			<Grid container direction="row" justifyContent="flex-end">
				<Paginate state={list.data?.pagination} setPage={setPage} />
			</Grid>
		</Page>
	);
}
